// src/pages/AdminLogin.js
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import styles from "../styles/AdminLogin.module.css";

const AdminLogin = ({ setIsAdminLoggedIn }) => {
  // تغییر prop از setAdminToken به setIsAdminLoggedIn
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setIsLoading(true);

    try {
      const response = await fetch(
        "https://backend.battery100.ir/api/admin/login",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ username, password }),
        }
      );

      const data = await response.json();

      if (response.ok) {
        // بجای توکن، یک پرچم ساده را ذخیره می‌کنیم
        localStorage.setItem("isAdminLoggedIn", "true");
        setIsAdminLoggedIn(true); // به‌روزرسانی وضعیت در App.js
        navigate("/admin/dashboard"); // رفتن به داشبورد ادمین
      } else {
        setError(data.message || "خطا در ورود به پنل ادمین.");
      }
    } catch (err) {
      console.error("Login error:", err);
      setError("خطا در ارتباط با سرور. لطفا دوباره تلاش کنید.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className={styles.container}>
      <h1 className={styles.title}>ورود به پنل ادمین</h1>
      <form onSubmit={handleSubmit} className={styles.orderForm}>
        <div className={styles.formGroup}>
          <label htmlFor="username">نام کاربری:</label>
          <input
            type="text"
            id="username"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            required
            className={styles.inputField}
          />
        </div>
        <div className={styles.formGroup}>
          <label htmlFor="password">رمز عبور:</label>
          <input
            type="password"
            id="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            className={styles.inputField}
          />
        </div>

        {error && (
          <div className={styles.submitError}>
            <p>{error}</p>
          </div>
        )}

        <button
          type="submit"
          className={styles.submitButton}
          disabled={isLoading}
        >
          {isLoading ? (
            <>
              <span className={styles.spinner}></span>
              در حال ورود...
            </>
          ) : (
            "ورود"
          )}
        </button>
      </form>
    </div>
  );
};

export default AdminLogin;
